module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/manual-placement.374778eb.svg";